// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separete[data-v-47b51041]{height:33px;background-color:#fff;border:1px solid #dcdfe6;padding:0 0 2px}.disabled[data-v-47b51041]{background-color:#f5f7fa;color:#c0c4cc!important}[data-v-47b51041] .el-input__inner{border:0}.fouce[data-v-47b51041]{border:1px solid #286ab4}", ""]);
// Exports
module.exports = exports;
